import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { css } from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const RedirectWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 54px;
`;

export const SignUpButton = styled(Button)`
    min-width: 360px;

    @media (max-width: ${breakpoints.xs}px) {
        min-width: 290px;
    }

    @media (max-width: ${breakpoints.xxs}px) {
        min-width: 210px;
    }
`;

export const LinkWrapper = styled(Typography.TextBody_16_24)`
    margin: 20px 0 8px;
`;

export const AuthLink = styled(Link)(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.tertiary.default};
        font-weight: ${fontWeight.bold};
        text-decoration: none;

        &:hover {
            color: ${palette.tertiary.hover};
        }
    `,
);
